module.exports = __webpack_public_path__ + "static/media/Enemy_09.1df116c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/RoleComponent/Enemy_09.png
// module id = 1642
// module chunks = 0